import { AxiosError } from 'axios';

export class ApiError extends Error {
  type?: number;
  message: string;
  axiosError: AxiosError;

  constructor(error: AxiosError) {
    super();
    this.axiosError = error;
    if (!error.response) {
      // Erreur réseau (pas de réponse du serveur)
      if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
        this.message = 'Délai d\'attente dépassé. Le serveur met trop de temps à répondre.';
      } else if (error.code === 'ERR_NETWORK' || error.message.includes('Network Error')) {
        this.message = 'Réseau indisponible. Vérifiez que le serveur API est démarré sur http://localhost:8000';
      } else if (error.code === 'ECONNREFUSED') {
        this.message = 'Connexion refusée. Le serveur API n\'est probablement pas démarré sur http://localhost:8000';
      } else {
        this.message = `Réseau indisponible: ${error.message || 'Erreur inconnue'}. Vérifiez que le serveur API est démarré.`;
      }
    } else {
      switch (error.response.status) {
        case 400: {
          this.type = 400;
          this.message = (error.response.data as any)?.message || 'Requête invalide.';
          break;
        }
        case 401: {
          this.type = 401;
          this.message = 'Veuillez vous connecter.';
          break;
        }
        case 403: {
          this.type = 403;
          this.message = "Vous n'avez pas accès.";
          break;
        }
        case 404: {
          this.type = 404;
          this.message = 'Ressource introuvable.';
          break;
        }
        case 422: {
          this.type = 422;
          const data = error.response.data as { message?: string; errors?: string[] };
          const errors = data?.errors;
          this.message =
            (Array.isArray(errors) && errors.find(Boolean)) || data?.message || 'Erreur de validation.';
          break;
        }
        case 502: {
          this.type = 502;
          const data = error.response.data as { message?: string; errors?: string[] };
          const errors = data?.errors;
          this.message =
            (Array.isArray(errors) && errors.find(Boolean)) || data?.message || 'Service externe indisponible.';
          break;
        }
        default: {
          this.message = 'Une erreur est survenue.';
        }
      }
    }
  }
}

export const checkError = (error: AxiosError): never => {
  const apiError = new ApiError(error);
  throw apiError;
};

